export default __webpack_public_path__ + "static/media/icon_hamburger.b8fe91f5.svg";